import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from 'src/js/modules/config/selectors/is-b2c';

const getCookieDomain = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.authtkt.cookie_domain');
  }

  return get(cfg, 'common.authtkt.wl_cookie_domain');
};

export default getCookieDomain;
